<template>
  <v-row dense align="center">
    <DatetimeRangePicker
      :type="type"
      :single-line="singleLine"
      :dense="dense"
      :hide-details="hideDetails"
      :hide-icon="hideIcon"
      v-model="datetimeRange"
      v-if="!$vuetify.theme.dark"
      :label="label"
      :disabled="disabled"
      :removeIcon="removeIcon"
    />
    <DatetimeRangePickerDark
      :type="type"
      :single-line="singleLine"
      :dense="dense"
      :hide-details="hideDetails"
      :hide-icon="hideIcon"
      v-model="datetimeRange"
      v-if="$vuetify.theme.dark"
      :label="label"
      :disabled="disabled"
      :removeIcon="removeIcon"
    />
  </v-row>
</template>

<script>
import DatetimeRangePicker from "@/plugins/datepicker/DatetimeRangePicker";
import DatetimeRangePickerDark from "@/plugins/datepicker/DatetimeRangePickerDark";

export default {
  name: "SearcherDatetimeRange",

  props: {
    value: Array,
    label: String,
    type: String,
    singleLine: Boolean,
    dense: Boolean,
    hideDetails: Boolean,
    hideIcon: Boolean,
    disabled: Boolean,
    removeIcon: Boolean,
  },

  components: {
    DatetimeRangePicker,
    DatetimeRangePickerDark,
  },

  data: () => ({
    datetimeRange: [
      new Date().toISOString().substr(0, 10) + " 00:00:00",
      new Date().toISOString().substr(0, 10) + " 23:59:59",
    ],
  }),

  watch: {
    value: {
      immediate: true, //初始赋值也调用
      handler() {
        this.datetimeRange = this.value;
      },
    },
    datetimeRange: {
      handler() {
        this.$emit("input", this.datetimeRange);
      },
    },
  },
};
</script>
